import type {
    GetPresidentResponseType
} from "./type";
import {
    request
} from "../request";

const getPresident = async (): Promise<GetPresidentResponseType> => {
    return await request<GetPresidentResponseType>("/content/getPresident", {
        method: "GET"
    });
};
export default getPresident;
